import startupsLandingStyles from "../../../../components/startups-landing/startups-landing-sections.module.css"
import styles from "../../../../components/hero/hero.module.css"
import illustrationPath from "./img/illustration.webp"
import { links } from "../../../../components/shared/constants/constants"

const Hero = () => {
	const handleTalkToAi = () => {
		window.location.href = `${links.startupsSignUp}?plan=hiring`
	}

	return (
		<section id="hero" className={styles.heroSection}>
			<div className={styles.heroBg} aria-hidden />
			<div className={styles.heroGrid} aria-hidden />
			<div className={`container ${startupsLandingStyles.sectionContainer} ${styles.heroShell}`}>
				<div className={styles.heroInner}>
					<div className={styles.heroCopy}>
						<div className={styles.label}>For agencies</div>
						<h1 className={`${styles.heroHeadline} ${styles.heroHeadlineStack3}`}>
							<span className={styles.heroHeadlineLine}>Professional Service</span>
							<span className={styles.heroHeadlineLine}>Automation Platform,</span>
							<span className={styles.heroHeadlineLine}>Connected</span>
						</h1>
						<p className={styles.heroSub}>
							Join the TechCore ecosystem to manage your team and match benched talents with startups, turning
							overhead into revenue.
						</p>
						<div className={styles.heroActions}>
							<button type="button" className={styles.btnPrimary} onClick={handleTalkToAi}>
								<span>Get Started</span>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
									<path
										d="M5.25 2.625L9.625 7L5.25 11.375"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<a href="#agencies-intro" className={styles.btnGhost}>
								See how it works
							</a>
						</div>
					</div>

					<div className={styles.illustration}>
						<div className={styles.illustrationFrame}>
							<img src={illustrationPath} alt="" />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Hero
